import React from 'react';
import {CashGiftGuideStyles} from './cash-gift-guide-styles';
import {PROGRESS_SETTLED_EMPHASIS_MS} from './constants';
import {ReferEarnWheelKeyframeStyles} from './wheel-keyframe-styles';

const ReferEarnWheelStyles = () => (
  <>
    <ReferEarnWheelKeyframeStyles />
    <CashGiftGuideStyles />
    <style>{`
    @font-face {
      font-family: 'Rowdies';
      src: url('/assets/fonts/Rowdies-Light.ttf') format('truetype');
      font-display: swap;
      font-style: normal;
      font-weight: 300;
    }
    @keyframes refer-earn-cash-gift-wait {
      0%, 100% {
        transform: translateY(0) rotate(0deg) scale(1);
        filter: drop-shadow(0 0 0 rgba(255, 217, 91, 0));
      }
      18% {
        transform: translateY(-0.2rem) rotate(0deg) scale(1.012);
        filter: drop-shadow(0 0 0.45rem rgba(255, 217, 91, 0.26));
      }
      31% {
        transform: translateY(-0.38rem) rotate(-3.45deg) scale(1.026);
        filter: drop-shadow(0 0 0.75rem rgba(255, 217, 91, 0.42));
      }
      46% {
        transform: translateY(-0.38rem) rotate(3.35deg) scale(1.026);
        filter: drop-shadow(0 0 0.75rem rgba(255, 217, 91, 0.42));
      }
      53% {
        transform: translateY(-0.4rem) rotate(-3.8deg) scale(1.03);
        filter: drop-shadow(0 0 0.86rem rgba(255, 217, 91, 0.48));
      }
      57% {
        transform: translateY(-0.39rem) rotate(3.55deg) scale(1.028);
        filter: drop-shadow(0 0 0.78rem rgba(255, 217, 91, 0.43));
      }
      61% {
        transform: translateY(-0.37rem) rotate(-3.2deg) scale(1.024);
        filter: drop-shadow(0 0 0.68rem rgba(255, 217, 91, 0.36));
      }
      66% {
        transform: translateY(-0.26rem) rotate(1.25deg) scale(1.014);
        filter: drop-shadow(0 0 0.48rem rgba(255, 217, 91, 0.24));
      }
      72% {
        transform: translateY(-0.08rem) rotate(0deg) scale(1.004);
        filter: drop-shadow(0 0 0.2rem rgba(255, 217, 91, 0.12));
      }
    }
    @keyframes refer-earn-cash-gift-energy-rise {
      0%, 20% {
        opacity: 0;
        transform: translate3d(0, 1.15rem, 0) scale(0.72);
      }
      42% {
        opacity: 0.92;
        transform: translate3d(0.04rem, -0.75rem, 0) scale(0.96);
      }
      70% {
        opacity: 0.36;
        transform: translate3d(-0.06rem, -2.35rem, 0) scale(0.82);
      }
      100% {
        opacity: 0;
        transform: translate3d(0, -2.85rem, 0) scale(0.68);
      }
    }
    @keyframes refer-earn-cash-gift-spark-a {
      0%, 12% {
        opacity: 0;
        transform: translate3d(0, 0.28rem, 0) scale(0.64);
      }
      30% {
        opacity: 0.86;
      }
      68% {
        opacity: 0.52;
        transform: translate3d(-0.3rem, -0.72rem, 0) scale(1);
      }
      100% {
        opacity: 0;
        transform: translate3d(-0.52rem, -1.08rem, 0) scale(0.74);
      }
    }
    @keyframes refer-earn-cash-gift-spark-b {
      0%, 22% {
        opacity: 0;
        transform: translate3d(0, 0.2rem, 0) scale(0.7);
      }
      38% {
        opacity: 1;
      }
      66% {
        opacity: 0.62;
        transform: translate3d(0.3rem, -0.62rem, 0) scale(0.98);
      }
      100% {
        opacity: 0;
        transform: translate3d(0.52rem, -1rem, 0) scale(0.72);
      }
    }
    @keyframes refer-earn-cash-gift-spark-center {
      0%, 18% {
        opacity: 0;
        transform: translate3d(0, 0.2rem, 0) scale(0.66);
      }
      36% {
        opacity: 0.9;
      }
      70% {
        opacity: 0.48;
        transform: translate3d(0.04rem, -1.55rem, 0) scale(0.96);
      }
      100% {
        opacity: 0;
        transform: translate3d(-0.04rem, -2.5rem, 0) scale(0.72);
      }
    }
    .refer-earn-cash-gift-item {
      overflow: visible;
      transform-origin: 50% 82%;
      -webkit-tap-highlight-color: transparent;
      transition:
        opacity 260ms ease,
        filter 260ms ease;
    }
    .refer-earn-cash-gift-idle {
      animation: refer-earn-cash-gift-wait 2.05s ease-in-out infinite;
      will-change: transform, filter;
    }
    .refer-earn-cash-gift-closed,
    .refer-earn-cash-gift-open {
      position: absolute;
      left: 50%;
      top: 0;
      z-index: 1;
      height: 8.5625rem;
      width: 8.96875rem;
      max-width: none;
      transform: translateX(-50%);
      transform-origin: 50% 100%;
      object-fit: contain;
    }
    .refer-earn-cash-gift-open {
      opacity: 0;
    }
    .refer-earn-cash-gift-open-flash {
      pointer-events: none;
      position: absolute;
      z-index: 3;
      top: -12%;
      right: -18%;
      bottom: -8%;
      left: -18%;
      border-radius: 50%;
      background: radial-gradient(
        circle,
        rgba(255, 252, 232, 0.96) 0%,
        rgba(255, 228, 140, 0.72) 36%,
        rgba(255, 196, 82, 0) 70%
      );
      opacity: 0;
      mix-blend-mode: screen;
    }
    @keyframes refer-earn-cash-gift-closed-out {
      0% {
        opacity: 1;
        filter: brightness(1);
        transform: translateX(-50%) scale(1);
      }
      28% {
        opacity: 1;
        filter: brightness(1.16);
        transform: translateX(-50%) translateY(0.18rem) scale(1.06, 0.88);
      }
      52% {
        opacity: 0.42;
        filter: brightness(1.4);
        transform: translateX(-50%) translateY(0.22rem) scale(1.08, 0.82);
      }
      100% {
        opacity: 0;
        filter: brightness(1.55);
        transform: translateX(-50%) translateY(0.28rem) scale(1.04, 0.78);
      }
    }
    @keyframes refer-earn-cash-gift-open-in {
      0%,
      36% {
        opacity: 0;
        filter: brightness(1.35);
        transform: translateX(-50%) translateY(0.2rem) scale(1.06, 0.84);
      }
      48% {
        opacity: 0.22;
        filter: brightness(1.28);
        transform: translateX(-50%) translateY(0.12rem) scale(1.03, 0.9);
      }
      68% {
        opacity: 0.85;
        filter: brightness(1.12);
        transform: translateX(-50%) translateY(0.04rem) scale(1.02, 1.03);
      }
      100% {
        opacity: 1;
        filter: brightness(1);
        transform: translateX(-50%) scale(1);
      }
    }
    @keyframes refer-earn-cash-gift-open-flash {
      0% {
        opacity: 0;
        transform: scale(0.62);
      }
      18% {
        opacity: 0.85;
        transform: scale(0.96);
      }
      34% {
        opacity: 1;
        transform: scale(1.06);
      }
      58% {
        opacity: 1;
        transform: scale(1.12);
      }
      100% {
        opacity: 0;
        transform: scale(1.28);
      }
    }
    .refer-earn-cash-gift-opened .refer-earn-cash-gift-closed {
      animation: refer-earn-cash-gift-closed-out 560ms
        cubic-bezier(0.45, 0.05, 0.55, 0.95) var(--refer-earn-cash-open-delay, 0ms)
        both;
    }
    .refer-earn-cash-gift-opened .refer-earn-cash-gift-open {
      animation: refer-earn-cash-gift-open-in 780ms
        cubic-bezier(0.45, 0.05, 0.55, 0.95) var(--refer-earn-cash-open-delay, 0ms)
        both;
    }
    .refer-earn-cash-gift-opened .refer-earn-cash-gift-open-flash {
      animation: refer-earn-cash-gift-open-flash 560ms
        cubic-bezier(0.45, 0.05, 0.55, 0.95) var(--refer-earn-cash-open-delay, 0ms)
        both;
    }
    @keyframes refer-earn-cash-gift-amount-enter {
      0% {
        opacity: 0;
        transform: translate(-50%, -0.22rem) scale(0.94);
      }
      100% {
        opacity: 1;
        transform: translate(-50%, 0) scale(1);
      }
    }
    @keyframes refer-earn-cash-gift-focused {
      0% {
        opacity: 0.92;
        transform: translate3d(0, 0, 0) scale(1);
        filter: brightness(1) drop-shadow(0 0 0.625rem rgba(255, 218, 91, 0.42));
      }
      58% {
        opacity: 0.8;
        transform: translate3d(
          var(--refer-earn-cash-focus-x, 0),
          var(--refer-earn-cash-focus-y, 0),
          0
        ) scale(1.36);
        filter: brightness(1.08) drop-shadow(0 0 0.875rem rgba(255, 218, 91, 0.58));
      }
      76% {
        opacity: 0.38;
        transform: translate3d(
          var(--refer-earn-cash-focus-x, 0),
          calc(var(--refer-earn-cash-focus-y, 0) - 0.18rem),
          0
        ) scale(1.5);
        filter: brightness(1.32) drop-shadow(0 0 1.375rem rgba(255, 218, 91, 0.86));
      }
      100% {
        opacity: 0;
        transform: translate3d(
          var(--refer-earn-cash-focus-x, 0),
          var(--refer-earn-cash-focus-y, 0),
          0
        ) scale(1.34);
        filter: brightness(1.08) drop-shadow(0 0 0.875rem rgba(255, 218, 91, 0.38));
      }
    }
    .refer-earn-cash-gift-opened {
      filter: drop-shadow(0 0 0.625rem rgba(255, 218, 91, 0.42));
    }
    .refer-earn-cash-gift-amount {
      background: var(
        --refer-earn-cash-gift-amount,
        #784204
      );
      background-clip: text;
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
      animation: refer-earn-cash-gift-amount-enter 560ms ease-in-out both;
    }
    .refer-earn-cash-gift-focused {
      z-index: 8;
      animation: refer-earn-cash-gift-focused 1500ms cubic-bezier(0.28, 0, 0.16, 1) both;
    }
    .refer-earn-cash-gift-focused:nth-child(odd) {
      --refer-earn-cash-focus-x: 5.0625rem;
    }
    .refer-earn-cash-gift-focused:nth-child(even) {
      --refer-earn-cash-focus-x: -5.0625rem;
    }
    .refer-earn-cash-gift-focused:nth-child(1),
    .refer-earn-cash-gift-focused:nth-child(2) {
      --refer-earn-cash-focus-y: 4.4375rem;
    }
    .refer-earn-cash-gift-focused:nth-child(3),
    .refer-earn-cash-gift-focused:nth-child(4) {
      --refer-earn-cash-focus-y: -7.1875rem;
    }
    .refer-earn-cash-gift-hidden {
      animation: none;
      filter: none;
      opacity: 0;
      pointer-events: none;
      transition: opacity 220ms ease;
    }
    .refer-earn-cash-gift-energy-rise,
    .refer-earn-cash-gift-energy-rise::before,
    .refer-earn-cash-gift-energy-rise::after,
    .refer-earn-cash-gift-spark,
    .refer-earn-cash-gift-spark::before,
    .refer-earn-cash-gift-spark::after {
      pointer-events: none;
      position: absolute;
      display: block;
    }
    .refer-earn-cash-gift-energy-rise {
      left: 50%;
      top: 3.45rem;
      z-index: 2;
      height: 3.7rem;
      width: 5.8rem;
      margin-left: -2.9rem;
      opacity: 0;
      transform: translate3d(0, 1.15rem, 0) scale(0.72);
      background:
        radial-gradient(circle, rgba(255, 214, 77, 0.92) 0 0.075rem, transparent 0.105rem) 22% 90% / 0.82rem 0.82rem no-repeat,
        radial-gradient(circle, rgba(255, 244, 166, 0.82) 0 0.065rem, transparent 0.095rem) 54% 84% / 0.76rem 0.76rem no-repeat,
        radial-gradient(circle, rgba(255, 255, 255, 0.72) 0 0.05rem, transparent 0.075rem) 76% 72% / 0.64rem 0.64rem no-repeat;
      animation: refer-earn-cash-gift-energy-rise 1.85s ease-out infinite;
      will-change: transform, opacity;
    }
    .refer-earn-cash-gift-energy-rise::before,
    .refer-earn-cash-gift-energy-rise::after {
      content: '';
      left: 50%;
      top: 0;
      height: 3.7rem;
      width: 3.8rem;
      opacity: 0;
      transform: translate3d(0, 1.15rem, 0) scale(0.68);
      background:
        radial-gradient(circle, rgba(255, 216, 91, 0.86) 0 0.07rem, transparent 0.1rem) 40% 88% / 0.8rem 0.8rem no-repeat,
        radial-gradient(circle, rgba(255, 255, 255, 0.76) 0 0.05rem, transparent 0.075rem) 58% 68% / 0.64rem 0.64rem no-repeat;
      animation: refer-earn-cash-gift-energy-rise 1.85s ease-out infinite;
      will-change: transform, opacity;
    }
    .refer-earn-cash-gift-energy-rise::before {
      margin-left: -2.95rem;
      animation-delay: 0.14s;
    }
    .refer-earn-cash-gift-energy-rise::after {
      margin-left: -0.85rem;
      animation-delay: 0.32s;
    }
    .refer-earn-cash-gift-spark {
      left: 50%;
      top: -0.05rem;
      z-index: 2;
      height: 3.25rem;
      width: 7.2rem;
      margin-left: -3.6rem;
      opacity: 0;
      transform: translate3d(0, 0.24rem, 0) scale(0.7);
      will-change: transform, opacity;
    }
    .refer-earn-cash-gift-spark-a {
      background:
        radial-gradient(circle, rgba(255, 244, 166, 0.78) 0 0.075rem, transparent 0.105rem) 12% 88% / 0.85rem 0.85rem no-repeat,
        radial-gradient(circle, rgba(255, 255, 255, 0.66) 0 0.055rem, transparent 0.08rem) 28% 68% / 0.7rem 0.7rem no-repeat,
        radial-gradient(circle, rgba(136, 250, 105, 0.52) 0 0.06rem, transparent 0.09rem) 46% 82% / 0.74rem 0.74rem no-repeat,
        radial-gradient(circle, rgba(255, 244, 166, 0.52) 0 0.05rem, transparent 0.075rem) 58% 58% / 0.68rem 0.68rem no-repeat;
      animation: refer-earn-cash-gift-spark-a 3.2s ease-out infinite;
    }
    .refer-earn-cash-gift-spark-b {
      background:
        radial-gradient(circle, rgba(255, 244, 166, 0.98) 0 0.075rem, transparent 0.105rem) 88% 88% / 0.85rem 0.85rem no-repeat,
        radial-gradient(circle, rgba(255, 255, 255, 0.9) 0 0.055rem, transparent 0.08rem) 72% 68% / 0.7rem 0.7rem no-repeat,
        radial-gradient(circle, rgba(255, 216, 91, 0.86) 0 0.065rem, transparent 0.095rem) 54% 82% / 0.75rem 0.75rem no-repeat,
        radial-gradient(circle, rgba(136, 250, 105, 0.5) 0 0.05rem, transparent 0.075rem) 42% 58% / 0.68rem 0.68rem no-repeat;
      animation: refer-earn-cash-gift-spark-b 2.15s ease-out infinite;
      animation-delay: 0.3s;
    }
    .refer-earn-cash-gift-spark::before,
    .refer-earn-cash-gift-spark::after {
      content: '';
      left: 50%;
      top: 0;
      height: 3.25rem;
      width: 4.4rem;
      opacity: 0;
      transform: translate3d(0, 0.24rem, 0) scale(0.68);
      background:
        radial-gradient(circle, rgba(255, 216, 91, 0.9) 0 0.07rem, transparent 0.1rem) 12% 88% / 0.8rem 0.8rem no-repeat,
        radial-gradient(circle, rgba(255, 255, 255, 0.8) 0 0.05rem, transparent 0.075rem) 38% 68% / 0.66rem 0.66rem no-repeat,
        radial-gradient(circle, rgba(255, 244, 166, 0.82) 0 0.06rem, transparent 0.09rem) 76% 84% / 0.72rem 0.72rem no-repeat;
      will-change: transform, opacity;
    }
    .refer-earn-cash-gift-spark-a::before,
    .refer-earn-cash-gift-spark-a::after {
      animation: refer-earn-cash-gift-spark-a 3.2s ease-out infinite;
    }
    .refer-earn-cash-gift-spark-b::before,
    .refer-earn-cash-gift-spark-b::after {
      animation: refer-earn-cash-gift-spark-b 2.15s ease-out infinite;
    }
    .refer-earn-cash-gift-spark::before {
      margin-left: -4.25rem;
    }
    .refer-earn-cash-gift-spark::after {
      margin-left: -0.18rem;
    }
    .refer-earn-cash-gift-spark-a::before {
      animation-delay: 0.82s;
    }
    .refer-earn-cash-gift-spark-a::after {
      animation-delay: 1.54s;
    }
    .refer-earn-cash-gift-spark-b::before {
      animation-delay: 0.52s;
    }
    .refer-earn-cash-gift-spark-b::after {
      animation-delay: 0.94s;
    }
    .refer-earn-cash-gift-spark-a::after,
    .refer-earn-cash-gift-spark-b::before {
      margin-left: -2.2rem;
      background:
        radial-gradient(circle, rgba(255, 244, 166, 0.9) 0 0.065rem, transparent 0.095rem) 42% 88% / 0.78rem 0.78rem no-repeat,
        radial-gradient(circle, rgba(255, 255, 255, 0.82) 0 0.05rem, transparent 0.075rem) 54% 66% / 0.66rem 0.66rem no-repeat,
        radial-gradient(circle, rgba(136, 250, 105, 0.58) 0 0.055rem, transparent 0.085rem) 62% 80% / 0.7rem 0.7rem no-repeat;
      animation: refer-earn-cash-gift-spark-center 2.7s ease-out infinite;
    }
    .refer-earn-cash-gift-spark-a::after {
      animation-delay: 0.58s;
    }
    .refer-earn-cash-gift-spark-b::before {
      animation-delay: 1.08s;
    }
    @keyframes refer-earn-cash-reward-title-breath {
      0%, 100% {
        transform: translateX(-50%) scale(1);
        filter: brightness(1);
      }
      42% {
        transform: translateX(-50%) translateY(0.1875rem) scale(1.065);
        filter: brightness(1.18) drop-shadow(0 0 0.5rem rgba(120, 66, 4, 0.24));
      }
      62% {
        transform: translateX(-50%) translateY(0.125rem) scale(1.035);
        filter: brightness(1.1) drop-shadow(0 0 0.3125rem rgba(120, 66, 4, 0.18));
      }
    }
    .refer-earn-cash-reward-title {
      -webkit-text-fill-color: transparent;
      animation: refer-earn-cash-reward-title-breath 2.15s ease-in-out infinite;
      transform-origin: center;
    }
    @keyframes refer-earn-cash-arrow-left-enter {
      0% {
        opacity: 0;
        transform: translateX(-2.25rem) scale(0.9);
        filter: brightness(0.95) drop-shadow(0 0 0 rgba(255, 232, 143, 0));
      }
      68% {
        opacity: 1;
        transform: translateX(0.18rem) scale(1.04);
        filter: brightness(1.18) drop-shadow(0 0 0.625rem rgba(255, 232, 143, 0.54));
      }
      100% {
        opacity: 1;
        transform: translateX(0) scale(1);
        filter: brightness(1) drop-shadow(0 0 0 rgba(255, 232, 143, 0));
      }
    }
    @keyframes refer-earn-cash-arrow-right-enter {
      0% {
        opacity: 0;
        transform: translateX(2.25rem) scale(0.9);
        filter: brightness(0.95) drop-shadow(0 0 0 rgba(255, 232, 143, 0));
      }
      68% {
        opacity: 1;
        transform: translateX(-0.18rem) scale(1.04);
        filter: brightness(1.18) drop-shadow(0 0 0.625rem rgba(255, 232, 143, 0.54));
      }
      100% {
        opacity: 1;
        transform: translateX(0) scale(1);
        filter: brightness(1) drop-shadow(0 0 0 rgba(255, 232, 143, 0));
      }
    }
    .refer-earn-cash-arrow-left {
      animation: refer-earn-cash-arrow-left-enter 620ms cubic-bezier(0.16, 1, 0.3, 1) 120ms both;
      transform-origin: center;
    }
    .refer-earn-cash-arrow-right {
      animation: refer-earn-cash-arrow-right-enter 620ms cubic-bezier(0.16, 1, 0.3, 1) 120ms both;
      transform-origin: center;
    }
    @keyframes refer-earn-reward-shine {
      0% {
        opacity: 0.72;
        transform: scale(0.96) rotate(0deg);
        filter: brightness(0.9);
      }
      45% {
        opacity: 1;
        transform: scale(1.08) rotate(9deg);
        filter: brightness(1.22);
      }
      100% {
        opacity: 0.82;
        transform: scale(1) rotate(18deg);
        filter: brightness(1);
      }
    }
    .refer-earn-withdraw-panel {
      background: linear-gradient(180deg, #314843 11.7%, rgba(60, 64, 63, 0.00) 100%), #343434;
    }
    @media (max-height: 42rem) {
      .refer-earn-withdraw-action {
        top: calc(100vh - 3.6875rem);
      }
      .refer-earn-withdraw-close {
        top: calc(100vh - 2.9375rem);
      }
    }
    .refer-earn-reward-shine {
      animation: refer-earn-reward-shine 2.2s ease-in-out infinite alternate;
      transform-origin: center;
    }
    .refer-earn-cash-gift-open-shine {
      opacity: 0;
      transform-origin: center;
    }
    .refer-earn-cash-gift-opened .refer-earn-cash-gift-open-shine {
      animation:
        refer-earn-cash-gift-shine-in 280ms ease-out 480ms both,
        refer-earn-reward-shine 2.2s ease-in-out 760ms infinite alternate;
    }
    @keyframes refer-earn-cash-gift-shine-in {
      0% {
        opacity: 0;
      }
      100% {
        opacity: 1;
      }
    }
    @keyframes refer-earn-achievement-coin {
      0% {
        opacity: 0;
        transform: translateX(-50%) translateY(1.25rem) scale(0.78);
        filter: brightness(0.95) drop-shadow(0 0 0 rgba(255, 230, 135, 0));
      }
      42% {
        opacity: 1;
        transform: translateX(-50%) translateY(-0.35rem) scale(1.08);
        filter: brightness(1.24) drop-shadow(0 0 1.25rem rgba(255, 230, 135, 0.9));
      }
      100% {
        opacity: 1;
        transform: translateX(-50%) translateY(0) scale(1);
        filter: brightness(1) drop-shadow(0 0 0.625rem rgba(255, 230, 135, 0.46));
      }
    }
    @keyframes refer-earn-achievement-amount {
      0%, 100% {
        transform: translateX(-50%) scale(1);
      }
      50% {
        transform: translateX(-50%) scale(1.055);
      }
    }
    @keyframes refer-earn-achievement-button {
      0%, 100% {
        transform: scale(1);
        box-shadow: 0 0 0 rgba(255, 191, 120, 0);
      }
      50% {
        transform: scale(1.018);
        box-shadow: 0 0 1rem rgba(255, 191, 120, 0.48);
      }
    }
    .refer-earn-achievement-coin {
      animation: refer-earn-achievement-coin 760ms cubic-bezier(0.16, 1, 0.3, 1) both;
    }
    .refer-earn-achievement-amount {
      animation: refer-earn-achievement-amount 1.3s ease-in-out infinite;
      transform-origin: center;
    }
    .refer-earn-achievement-button {
      animation: refer-earn-achievement-button 1.5s ease-in-out infinite;
      transform-origin: center;
    }
    .refer-earn-amount-text {
      display: inline-flex;
      align-items: baseline;
      white-space: nowrap;
      color: inherit;
      font-variant-numeric: tabular-nums;
    }
    .refer-earn-amount-prefix,
    .refer-earn-amount-target {
      display: inline-flex;
      align-items: baseline;
    }
    .refer-earn-amount-prefix {
      margin-right: 0.25rem;
    }
    .refer-earn-amount-text span {
      color: inherit;
      -webkit-text-fill-color: currentColor;
    }
    .refer-earn-amount-static-char,
    .refer-earn-amount-roll-char {
      display: inline-block;
      min-width: 0.36em;
      text-align: center;
    }
    .refer-earn-amount-static-char {
      transform: translateZ(0);
    }
    .refer-earn-amount-roll-char {
      height: 1em;
      overflow: hidden;
      vertical-align: baseline;
    }
    .refer-earn-amount-roll-track {
      display: flex;
      flex-direction: column;
      animation: refer-earn-amount-roll 1200ms cubic-bezier(0.18, 0.9, 0.2, 1) both;
      will-change: transform;
    }
    .refer-earn-amount-roll-track > span {
      display: block;
      height: 1em;
      line-height: 1em;
    }
    @keyframes refer-earn-amount-roll {
      0% {
        transform: translate3d(0, 0, 0);
        filter: brightness(1);
      }
      58% {
        filter: brightness(1.28);
      }
      100% {
        transform: translate3d(0, var(--amount-roll-distance), 0);
        filter: brightness(1);
      }
    }
    @keyframes refer-earn-progress-settled-emphasis {
      0% {
        transform: translateX(-50%) scale(1);
        box-shadow: 0 0 0 rgba(255, 235, 165, 0);
      }
      50% {
        transform: translateX(-50%) scale(1.18);
        box-shadow: 0 0 0.875rem rgba(255, 232, 145, 0.88);
      }
      100% {
        transform: translateX(-50%) scale(1);
        box-shadow: 0 0 0 rgba(255, 235, 165, 0);
      }
    }
    .refer-earn-progress-settled-emphasis {
      animation: refer-earn-progress-settled-emphasis ${PROGRESS_SETTLED_EMPHASIS_MS}ms ease-in-out both;
      transform-origin: center;
      will-change: transform, box-shadow;
    }
    .refer-earn-progress-lottie svg {
      display: block;
      width: 100% !important;
      height: 100% !important;
    }
    @keyframes refer-earn-invite-button-pulse {
      0%, 100% {
        transform: scale(1);
        box-shadow: 0 0.25rem 0.125rem rgba(255, 206, 30, 0.4);
      }
      50% {
        transform: scale(1.025);
        box-shadow:
          0 0.25rem 0.125rem rgba(255, 206, 30, 0.48),
          0 0 0.75rem rgba(255, 206, 30, 0.2);
      }
    }
    @keyframes refer-earn-static-invite-button-breath {
      0%, 100% {
        transform: translate3d(0, 0, 0);
      }
      50% {
        transform: translate3d(0, 0.1875rem, 0);
      }
    }
    .refer-earn-static-invite-button {
      animation: refer-earn-static-invite-button-breath 1.45s ease-in-out infinite;
      will-change: transform;
    }
    @keyframes refer-earn-modal-backdrop-in {
      0% {
        opacity: 0;
      }
      100% {
        opacity: 1;
      }
    }
    @keyframes refer-earn-modal-backdrop-out {
      0% {
        opacity: 1;
      }
      100% {
        opacity: 0;
      }
    }
    @keyframes refer-earn-modal-panel-in {
      0% {
        opacity: 0;
        transform: translateY(1rem) scale(0.96);
      }
      100% {
        opacity: 1;
        transform: translateY(0) scale(1);
      }
    }
    @keyframes refer-earn-modal-panel-out {
      0% {
        opacity: 1;
        transform: translateY(0) scale(1);
      }
      100% {
        opacity: 0;
        transform: translateY(0.75rem) scale(0.96);
      }
    }
    @keyframes refer-earn-cash-modal-collapse {
      0% {
        opacity: 1;
        transform: scale(1);
      }
      100% {
        opacity: 0;
        transform: scale(0.62) translateY(1.5rem);
      }
    }
    `}</style>
  </>
);

export default ReferEarnWheelStyles;
